import styles from "./CardComments.module.css"

import IconIosChatbubblesOutline from "@shared/components/icons/IosChatbubblesOutline"
import type { Comment } from "@shared/models/comment"
import { tracked } from "@supergrain/kernel/react"
import { useUiContext } from "../../unified-tiptap-ui-context"
import CommentItem from "./CommentItem"

interface Props {
  /** The reactive comments to render (viewable & non-deleted), from `useCardComments`. */
  comments: Comment[]
}

/**
 * Renders a card's comments.
 */
export default tracked(function CardComments({ comments }: Props) {
  const {
    permissions,
    currentUserId,
    commentActions: { deleteComment },
  } = useUiContext()

  if (comments.length === 0) return null

  return (
    <div className={styles.commentsList}>
      <div className={styles.header}>
        <IconIosChatbubblesOutline />
        Comments
      </div>

      {comments.map((comment) => (
        <CommentItem
          key={comment.id}
          comment={comment}
          currentUserId={currentUserId}
          // Only show the Delete Comment if this editor allows commenting,
          // so that it doesn't show up in LessonSimpleReadonly (e.g. the version history).
          deleteComment={permissions.canComment ? deleteComment : undefined}
        />
      ))}
    </div>
  )
})
